import { useFormContext } from "react-hook-form";

/**
 * Datos que la autorización seleccionada impone sobre el formulario de registro.
 * Sólo lo que los componentes de vehículo necesitan; el resto de los campos
 * (remito, precinto, notas, mercadería en tránsito) se escriben directo con setValue.
 */
export type AuthorizationPrefill = {
  vehiclePlate: string;
  /** null equivale a "No aplica": no se agrega vehículo asociado. */
  trailerPlate: string | null;
};

/**
 * `ObservationsForm` y los formularios de vehículo se comparten con los flujos de personas y
 * visitas: nada de esto puede alterarlos fuera de transportistas. Estos dos hooks son el único
 * punto por donde se lee el estado de prefill/lock, así que con este guard alcanza para que todo
 * el código nuevo quede inerte cuando el método de acceso no es transporte.
 */
const useIsTransport = (): boolean => {
  const { watch } = useFormContext();
  return watch("selectedAccessMethod") === "transport";
};

/** Devuelve un predicado: ¿este campo está impuesto por la autorización y por lo tanto bloqueado? */
export const useTransportFieldLock = (): ((name: string) => boolean) => {
  const { watch } = useFormContext();
  const isTransport = useIsTransport();
  const locked = (watch("transportLockedFields") as string[] | undefined) ?? [];

  return (name: string) => isTransport && locked.includes(name);
};

export const useTransportAuthPrefill = (): AuthorizationPrefill | null => {
  const { watch } = useFormContext();
  const isTransport = useIsTransport();

  if (!isTransport) return null;
  return (watch("transportAuthPrefill") as AuthorizationPrefill | undefined) ?? null;
};
